const deviceSizes = {
  mobile: "475px",
};

const device = {
  mobile: `screen and (max-width: ${deviceSizes.mobile})`,
};

const theme = {
  device
};

export default theme;